<template>
    <van-form>
        <van-field label="原手机号" :value="$store.state.userInfo.phone_desensitization" readonly />
        <van-field v-model="original_verification_code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
                <van-button size="small" type="primary" @click="sendOriginalSms" :disabled="!!original_send_interval">{{original_send_interval ? original_send_interval + 's后重试' : '发送验证码'}}</van-button>
            </template>
        </van-field>
        <van-field v-model="phone" required label="更换手机号" clearable placeholder="请输入手机号" style="margin-top: 20px;" />
        <van-field v-model="verification_code" center clearable label="短信验证码" placeholder="请输入短信验证码">
            <template #button>
                <van-button size="small" type="primary" @click="sendSms" :disabled="!!send_interval">{{send_interval ? send_interval + 's后重试' : '发送验证码'}}</van-button>
            </template>
        </van-field>
        <van-button type="primary" block style="margin-top: 20px;" @click="login">更换</van-button>
    </van-form>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";

    export default {
        name: "ModifyPhone",
        data(){
            return {
                original_verification_code:'',
                phone : '',
                verification_code : '',
                send_interval : null,
                original_send_interval : null,
            };
        },
        methods : {
            sendOriginalSms(){
                let self = this;
                api.request('/common/send_bind_phone_sms_verification_code', {
                    'type' : 'modify_phone',
                }).then(res => {
                    self.original_send_interval = res.data.send_interval;
                    let setSmsTimer = setInterval(function () {
                        self.original_send_interval--;
                        if(self.original_send_interval <= 0){
                            clearInterval(setSmsTimer);
                            self.original_send_interval = null;
                        }
                    }, 1000);
                    self.$toast(res.msg);
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            sendSms(){
                let self = this;
                api.request('/common/send_sms_verification_code', {
                    'phone' : this.phone,
                    'type' : 'modify_phone',
                }).then(res => {
                    self.send_interval = res.data.send_interval;
                    let setSmsTimer = setInterval(function () {
                        self.send_interval--;
                        if(self.send_interval <= 0){
                            clearInterval(setSmsTimer);
                            self.send_interval = null;
                        }
                    }, 1000);
                    self.$toast(res.msg);
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            login(){
                let self = this;
                api.request('/user/modify_phone', {
                    original_verification_code : this.original_verification_code,
                    phone : this.phone,
                    verification_code : this.verification_code,
                }).then(res => {
                    self.$toast(res.msg);
                    self.$store.commit('refreshUserInfo');  //同步用户信息
                    self.$router.back();
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/ModifyPhone.vue